import { Flex } from 'foundations-components/components/Flex';
import SkeletonBase from '../../_core/common/components/loading/SkeletonBase';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const LoadingBanner = ({
  marginStyle,
  className,
  style
}) => {
  return /*#__PURE__*/_jsxs(Flex, Object.assign({
    justifyContent: "center",
    alignItems: "center",
    paddingBlock: "200",
    paddingInline: "400",
    backgroundColor: "fill-primary-subtle",
    role: "alert"
  }, marginStyle, {
    // @ts-expect-error temporary while we cut over to marginStyle
    className: className,
    style: style,
    children: [/*#__PURE__*/_jsx(SkeletonBase, {
      circleSize: "24px",
      shape: "circle",
      wrapperWidth: "auto"
    }), /*#__PURE__*/_jsx(SkeletonBase, {
      height: "12px",
      marginStyle: {
        marginInlineStart: '400'
      }
    })]
  }));
};
export default LoadingBanner;